import { createFileRoute } from '@tanstack/react-router';

import { InSeasonTable } from '../../../new/tables/in-season';

export const Route = createFileRoute('/new/in-season/')({
  component: RouteComponent,
});

function RouteComponent() {
  return <InSeasonTable />;
}
